const cookieName = 'USER_ANUID';

export const setCookie = (value) => {
  document.cookie = `${cookieName}=${value}; expires=${new Date(
    Date.now() + 60 * 60 * 24 * 365 * 1000
  ).toUTCString()}; path=/`;
};

export const getCookie = () => {
  const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`));

  if (cookie) {
    return cookie.split('=')[1];
  }

  return null;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/cookie.js